import { useDeviceType } from '@cian/ui-kit';
import { Sravnenie16 } from '@cian/ui-kit/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CompareOnboarding } from '../../components/CompareOnboarding';
import { Utility } from '../../components/Utility';
import { selectRegionId } from '../../selectors/geo';
import { selectPageType } from '../../selectors/page';
import { useApplicationContext } from '../../utils/applicationContext';
import { incrementCompareOnboardingCounter, isCompareOnboardingAvailable } from './helpers';
import { trackingCompareIconClick } from './tracking';

export const UtilityCompareContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const deviceType = useDeviceType();

  const pageType = useSelector(selectPageType);
  const regionId = useSelector(selectRegionId);

  const isComparePage = pageType === 'mainCompare';
  const isOnboardingAvailableInRegion = React.useMemo<boolean>(
    () => !(config.get<number[]>('offers-compare.disabledOnboardingRegions') || []).includes(regionId),
    [config, regionId],
  );
  const [onboardingOpened, setOnboardingOpened] = React.useState(false);

  const handleClick = React.useCallback(trackingCompareIconClick, []);
  const handleClose = React.useCallback(() => {
    setOnboardingOpened(false);
  }, []);

  React.useEffect(() => {
    const isOnboardingAvailable = isOnboardingAvailableInRegion && isCompareOnboardingAvailable() && !isComparePage;

    if (isOnboardingAvailable) {
      setOnboardingOpened(true);
      incrementCompareOnboardingCounter();
    }
    const timer = setTimeout(handleClose, 20000);

    return () => {
      clearTimeout(timer);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (deviceType === 'phone') {
    return null;
  }

  return (
    <>
      <Utility title="Сравнение объектов" icon={Sravnenie16} href="/compare/" onClick={handleClick} />
      {onboardingOpened && <CompareOnboarding onClose={handleClose} />}
    </>
  );
};
